const API_URL = process.env.REACT_APP_API_URL;

export async function fetchProjects(userId: string) {
  const response = await fetch(`${API_URL}/api/projects/list?userId=${userId}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch projects: ${response.status}`);
  }
  return response.json();
}

export async function fetchDocuments(userId: string) {
  const response = await fetch(`${API_URL}/api/projects/files/list?userId=${userId}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch documents: ${response.status}`);
  }
  return response.json();
}

export async function createOrUpdateProject(newProject: any) {
  const response = await fetch(`${API_URL}/api/projects/update`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(newProject)
  });
  
  if (!response.ok) {
    throw new Error(`Failed to create or update project: ${response.status}`);
  }
}

export async function updateProject(projectId: string, updatedProject: any) {
  await fetch(`${API_URL}/api/projects/${projectId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedProject)
  });
}

export async function deleteProject(projectId: string) {
  const response = await fetch(`${API_URL}/api/projects/delete?projectId=${projectId}`, {
    method: 'DELETE',
  });
  
  if (!response.ok) {
    throw new Error(`Failed to delete project: ${response.status}`);
  }
}

// This function is used to refresh the revisions of a project
// It refreshes the number of charactes in the project
// It Also generates a AI summary for the changes in the project
export async function refreshProject(userId: string, projectId: string) {
  const response = await fetch(`${API_URL}/api/projects/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, projectId })
  });
  
  if (!response.ok) {
    throw new Error(`Failed to refresh project: ${response.status}`);
  }
  
  return response.json();
}

export async function generateAiSummary(comparisionId: string, summaryType: 'formal' | 'friendly' | 'business', userId: string) {
  const body: any = { comparisionId: comparisionId, summaryType };
  if (userId) body.userId = userId;
  const response = await fetch(`${API_URL}/api/projects/generateAiSummary`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  
  if (!response.ok) {
    throw new Error(`Failed to generate AI summary: ${response.status}`);
  }
  
  return response.json();
}

export async function saveAiSummary(comparisionId: string) {
  const response = await fetch(`${API_URL}/api/projects/saveAiSummary`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 'comparisionId':comparisionId })
  });
  
  if (!response.ok) {
    throw new Error(`Failed to save AI summary: ${response.status}`);
  }
  
  return response.json();
}
